export default "__VITE_ASSET__C$0xISmP__"